import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { communityCreatorPausePath, communityCreatorStagePath, newAccountPath } from "@travily/routes";
import communityIllustration from "@ui/assets/illustrations/community-animated.webp";
import { useAvatarKindField } from "@/hooks/use-avatar-kind-field";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { AccountPictureStepView } from "@/pages/account/creator/components/AccountPictureStepView";

interface PageProps {
  stage_index: number;
  total_stages: number;
  stage_order: string[];
  profileable_id: number;
  profile_type: string;
  initial: string | null;
  avatar_kind: string;
  avatar_url: string | null;
}

type FormData = {
  avatar_kind: string;
  signed_id: string;
};

const CommunityPictureStep = ({
  stage_index,
  stage_order,
  profileable_id,
  profile_type,
  initial,
  avatar_kind,
  avatar_url,
}: PageProps) => {
  const { form, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } = useWizardForm<FormData>({
    routes: {
      stageUrl: (stage) => communityCreatorStagePath(profileable_id, stage),
      entryUrl: newAccountPath(),
      pauseUrl: communityCreatorPausePath(profileable_id),
    },
    stageName: "picture",
    stageIndex: stage_index,
    stageOrder: stage_order,
    initialData: { avatar_kind, signed_id: "" },
  });

  const picture = useAvatarKindField({
    initialAvatarKind: avatar_kind,
    initialAvatarUrl: avatar_url,
    onFieldsChange: ({ avatarKind, signedId }) => form.setData({ avatar_kind: avatarKind, signed_id: signedId }),
  });

  const topBarActions = useCreatorTopBarActions({ onPause });

  return (
    <>
      <Head title={t("web.communities.creator.steps.picture.show.meta_title")}>
        <meta name="description" content={t("web.communities.creator.steps.picture.show.meta_description")} />
      </Head>
      <AccountPictureStepView
        color="yellow"
        illustration={<img alt="" aria-hidden="true" src={communityIllustration} />}
        heading={t("web.communities.creator.steps.picture.show.title")}
        helper={t("web.communities.creator.steps.picture.show.subtitle")}
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        profileType={profile_type}
        initial={initial}
        selection={picture.selection}
        uploadPreview={picture.previewUrl}
        onFileSelect={picture.onFileSelect}
        onRemove={picture.onRemove}
        onSelectionChange={picture.onSelectionChange}
      />
    </>
  );
};

export default CommunityPictureStep;
